<template>
  <div class="relative max-w-full overflow-x-clip overflow-y-visible [&_*]:!cursor-grab [&_*]:select-none">
    <Carousel class="!w-full !max-w-full whitespace-nowrap !p-0">
      <slot />
    </Carousel>
  </div>
</template>
